import { Component, OnInit } from '@angular/core';
import {BordereauService } from '../../../../bordereau/bordereau.service';
import { NgForm } from '@angular/forms';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-xsp-report',
  templateUrl: './xsp-report.component.html',
  styleUrls: ['./xsp-report.component.css']
})
export class XspReportComponent implements OnInit {

  constructor(private bordereauService: BordereauService) { }

  start_date: string = '';
  end_date: string = '';
  ngOnInit(): void {
  }
  onSubmit(f: NgForm) {
    let data: any = '';
    data = {
      start_date: formatDate(this.start_date, 'yyyy-MM-dd', 'en-US'),
      end_date: formatDate(this.end_date, 'yyyy-MM-dd', 'en-US'),
  
    };
    this.bordereauService.policyExcessProtect(data)
      .subscribe(
        (response: any) => {  
          var blob=new Blob([response], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            var link=document.createElement('a');
            link.href=window.URL.createObjectURL(blob);
            link.download="policies.xlsx";
            link.click();          
        });
  }
}
